import { c as _c } from "react/compiler-runtime";
import { parseAsArrayOf, parseAsString, parseAsStringEnum, useQueryState } from 'nuqs';
import { useCallback, useMemo } from 'react';
import { type ScopeOfWork_Deliverable, ScopeOfWork_DeliverableStatus } from '@/modules/__generated__/graphql/switchboard-generated';
interface UseDeliverableFiltersProps {
  deliverables: ScopeOfWork_Deliverable[];
}
function useDeliverableFilters(t0) {
  const $ = _c(22);
  const {
    deliverables: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const deliverables = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = parseAsString.withDefault("");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [search, setSearch] = useQueryState("search", t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = parseAsArrayOf(parseAsStringEnum(Object.values(ScopeOfWork_DeliverableStatus))).withDefault([]);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [statuses, setStatuses] = useQueryState("statuses", t4);
  let t5;
  if ($[4] !== deliverables || $[5] !== search || $[6] !== statuses) {
    let t6;
    if ($[8] !== statuses) {
      t6 = deliverable => {
        const statusMatch = statuses.length === 0 || statuses.includes(deliverable.status);
        return statusMatch;
      };
      $[8] = statuses;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== search) {
      t7 = deliverable_0 => {
        const filteredKeyResults = deliverable_0.keyResults.filter(keyResult => {
          const searchMatch = search === "" || keyResult.title.toLowerCase().includes(search.toLowerCase()) || keyResult.link.toLowerCase().includes(search.toLowerCase());
          return searchMatch;
        });
        return {
          ...deliverable_0,
          keyResults: filteredKeyResults
        };
      };
      $[10] = search;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    t5 = deliverables.filter(t6).map(t7).filter(_temp);
    $[4] = deliverables;
    $[5] = search;
    $[6] = statuses;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const filteredDeliverables = t5;
  let t6;
  if ($[12] !== setSearch || $[13] !== setStatuses) {
    t6 = () => {
      setSearch("");
      setStatuses([]);
    };
    $[12] = setSearch;
    $[13] = setStatuses;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const onReset = t6;
  let t7;
  if ($[15] !== filteredDeliverables || $[16] !== onReset || $[17] !== search || $[18] !== setSearch || $[19] !== setStatuses || $[20] !== statuses) {
    t7 = {
      search,
      statuses,
      setSearch,
      setStatuses,
      onReset,
      filteredDeliverables
    };
    $[15] = filteredDeliverables;
    $[16] = onReset;
    $[17] = search;
    $[18] = setSearch;
    $[19] = setStatuses;
    $[20] = statuses;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp(deliverable_1) {
  return deliverable_1.keyResults.length > 0;
}
export { useDeliverableFilters };